







import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import ApplyCoupon from './components/ApplyCoupon.vue';
import AppliedCoupon from './components/AppliedCoupon.vue';

import { ICheckoutCartOfferCoupon } from '@/interfaces/Checkout';

const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    ApplyCoupon,
    AppliedCoupon
  }
})
export default class Coupon extends Vue {
  @CheckoutModule.Getter
  private selectedOfferCoupon: ICheckoutCartOfferCoupon | null;
}
